module.exports = __webpack_public_path__ + "media/images/talent/lp/conversion_text-4b7c36ddff190ae788d6209251b6d6c3.svg";